export default "__VITE_ASSET__ChlLLqxq__"